export default "__VITE_ASSET__HjVUT5MpswcpgY2Kt4Q2FQ__"